import type { SVGProps } from 'react';

interface TeamPlaceholderMediumIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const TeamPlaceholderMediumIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & TeamPlaceholderMediumIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 32 33"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <mask
      height={33}
      id="team-placeholder-medium_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
      width={32}
      x={0}
      y={0}
    >
      <path d="M32 .143H0v32h32z" fill="#fff" />
    </mask>
    <g fill="#97ACCC" mask="url(#team-placeholder-medium_svg__a)">
      <path d="M5.27 23.924a12.73 12.73 0 0 1-2.07-6.98c0-1.613.299-3.154.843-4.577l1.273.394c1.945.6 3.363.555 3.878 1.315.243.356.12 3.282 0 6.116-.1 2.361-.68 2.567-2.668 3.272-.37.13-.786.279-1.255.462zM12.952 29.377a12.8 12.8 0 0 1-6.965-4.463c1.576-.612 3.248-1.194 3.592-1.277.457-.108.93.108 1.586.41.311.142.665.305 1.08.458 1.038.39.966 1.303.9 2.108-.015.189-.03.372-.03.54 0 .366-.065 1.252-.163 2.22zM21.316 28.59A12.75 12.75 0 0 1 16 29.744q-1.175-.002-2.291-.204c.188-1.478.251-3.021.329-3.52l.005-.03q.006-.041.012-.078c.076-.49.103-.67.206-.736.06-.037.319-.027.457-.022l.178.002c.286 0 1.408-.135 2.532-.268 1.125-.136 2.247-.269 2.533-.269.57 0 1.107 1.074 1.275 2.653q.08.736.085 1.32zM27.473 22.628a12.85 12.85 0 0 1-5.494 5.637 6 6 0 0 0-.098-.999 37 37 0 0 0-.16-.765c-.254-1.18-.43-1.998-.025-2.35.487-.424 2.77-1.555 4.186-2.087.607-.229 1.132.06 1.589.564zM23.92 6.89a12.77 12.77 0 0 1 4.878 10.054c0 .883-.09 1.744-.258 2.575-1.923 1.363-4.483 2.775-5.439 3.152-1.42.557-1.393.022-1.302-1.574l.025-.502c.037-.813.057-1.832.05-3.295.14-2.058.093-3.11.284-3.844.195-.746.446-2.09.958-3.822.357-1.2.675-2.28.803-2.743M22.687 6.028q-.09.075-.191.155c-1.202.954-5.015 3.606-5.707 3.606s-1.735-.248-2.688-2.474c-.317-.735-.801-1.634-1.28-2.522l-.12-.221a12.9 12.9 0 0 1 3.294-.43c2.453 0 4.742.688 6.687 1.883zM4.484 11.346a12.84 12.84 0 0 1 6.845-6.322c.361 1.049.855 1.897 1.297 2.653.44.752.826 1.415.979 2.098.309 1.38-2.79 3.041-3.544 3.247-.356.098-.803-.118-1.403-.41-.665-.32-1.52-.734-2.653-.913a13 13 0 0 1-1.518-.356zM20.647 19.471c.178 2.008.336 3.777-1.097 4.181-1.453.41-3.632.316-4.902 0l-.524-.128c-1.42-.341-3.742-.896-3.878-1.55-.319-1.542-.09-3.356.18-5.168.274-1.814.365-2.221.794-2.495.22-.137.931-.88 1.671-1.65.71-.741 1.446-1.51 1.802-1.8.415-.339 1.521.24 2.656.835l2.336.984c.763.322.97 2.48.931 4.548-.014.813-.027 1.586.023 2.16l.008.08zM21.647 11.576c.331-.85 1.651-4.359.848-4.12-.8.235-5.655 3.335-4.59 3.689.188.062 1.385.476 1.593.554.97.361 1.875.58 2.149-.12z" />
    </g>
  </svg>
);
